import { IntegrationIconProps } from './types';

const JiraOps = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.391 10.6154L8.76562 24.1907C8.97427 24.4017 9.17473 24.6044 9.41609 24.7989L15.1885 29.7226C15.6237 30.0924 16.2588 30.0924 16.694 29.7226C17.7331 28.8288 19.7663 27.0911 22.1841 25.0306C26.8274 21.0627 27.2365 15.2411 23.391 10.6154Z"
      fill="url(#paint0_linear_1334_1147)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.65171 10.6166C5.0213 14.6497 5.15362 20.4989 8.83364 24.1846L16.0986 17.5164C20.5436 13.4336 20.8868 6.13661 16.4997 2C16.4997 2 12.2821 6.58336 8.65171 10.6166Z"
      fill="#2684FF"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1334_1147"
        x1="10.5943"
        y1="18.3236"
        x2="21.3967"
        y2="20.209"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0052CC" />
        <stop offset="1" stopColor="#2684FF" />
      </linearGradient>
    </defs>
  </svg>
);
export default JiraOps;
